import AreasView from "../AreasView.vue";
import AreaList from "../Pages/AreaList.vue";
import AreaEditor from "../Pages/AreaEditor.vue";

const routes = [
  {
    path: '/areas',
    component: AreasView,
    children: [
      {
        path: '',
        name: 'area-list',
        component: AreaList,
      },
      {
        path: 'crear',
        name: 'area-create',
        component: AreaEditor,
      },
      {
        path: ':id',
        name: 'area-edit',
        component: AreaEditor,
      },
    ]
  }
]

export default routes
